import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingsService } from '../_services/settings.service';
import { Observable } from 'rxjs';

@Injectable()
export class HttpBearerInterceptor implements HttpInterceptor {
  constructor(private settingsService: SettingsService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.settingsService.bearerToken !== null) {
      const authToken = `Bearer ${this.settingsService.bearerToken}`;

      const authReq = req.clone({
        headers: req.headers.set('Authorization', authToken),
      });
      return next.handle(authReq);
    }

    return next.handle(req);
  }
}
